import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import {
	post,
	get,
	_post,
	_posts,
	_getNew,
	_postNew
} from './service/http'
import {
	Swipe,
	SwipeItem,
	Lazyload,
	List,
	Tabbar,
	TabbarItem,
	Popup,
	Cell,
	CellGroup,
	Search,
	Tab,
	Tabs,
	NavBar,
	Calendar,
	Dialog,
	Field,
	DropdownMenu,
	DropdownItem,
	Sidebar,
	SidebarItem,
	IndexBar,
	IndexAnchor,
	Picker,
	DatetimePicker,
	Collapse,
	CollapseItem,
	Rate,
	AddressEdit
} from 'vant';

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$_post = _post
Vue.prototype.$_posts = _posts
Vue.prototype.$_getNew = _getNew
Vue.prototype.$_postNew = _postNew

Vue.prototype.$connectHttpSweet = "https://mer.sweetour.com:9000/api/services/app"
Vue.prototype.$apiWebsiteSweet = "https://applet.sweetour.com"
Vue.prototype.$apiList = "https://open.sweetour.com:9000/api/services/app"
Vue.prototype.$login = "https://open.sweetour.com:9000"
Vue.prototype.$connectHttpDayun = "https://api.dayuntong.com"
Vue.prototype.$severOrder = "https://mer.sweetour.com:8085/api/services/app"
Vue.prototype.$activity = "https://activity.sweetour.com"
Vue.prototype.$domainUrl = "https://liner.sweetour.com"
Vue.prototype.$connectHttpSweetApi = 'https://zb.dayuntong.com:4433'
Vue.prototype.$service = 'https://service.sweetour.com'
Vue.prototype.$dbqnr = "https://dbqnr.sweetour.com/apiRretailStore"
Vue.prototype.$lyh = "https://fy.sweetour.com:8074"
Vue.prototype.$apiNearTravel = "https://mer.sweetour.com:9000"

Vue.prototype.$organizationId = 77 //交行买单吧 OrgId=77
Vue.prototype.$platformid = "26" //"26"


Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
Vue.use(List);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Search);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(NavBar);
Vue.use(Calendar);
Vue.use(Dialog);
Vue.use(Field);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Picker);
Vue.use(DatetimePicker);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Rate);
Vue.use(AddressEdit);

Vue.config.productionTip = false
new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')